<template>
    <div class="easy-camera-page">
        <div class="easy-camera-header">
            <el-icon @click.stop="closePage" ><ArrowLeft /></el-icon>
        </div>
        <div class="easy-camera-content">
            <div></div>
            <div class="easy-camera-container">
                <div class="easy-camera-photo-preview" v-if="photo">
                    <img :src="photo" />
                </div>
                <div v-else style="width: 100%;position: relative;box-sizing: border-box;" :style="cameraContentHeight">
                    <div class="easy-camera-mask-img-container" ref="IDCardImgContainer">
                        <img :src="maskSrc"  @load="getCameraHeight()" class="easy-camera-mask-img"/>
                    </div>
                    <div style="width: 100%;height: 100%;" ref="camera_container">
                        <!-- 相机压缩了调这俩 -->
                        <camera :resolution="{ width: 500, height: 800 }" ref="camera" autoplay>
                            <!-- <div style="width: 100%;height: 100%;">
                                <img :src="require('@/assets/images/camera/'+this.mask)" class="easy-camera-mask-img"/>
                            </div> -->
                        </camera>
                    </div>
                </div>
            </div>
            <div class="easy-camera-footer">
                <div class="easy-camera-btn" @click.stop="snapshot" v-show="!photo"></div>
                <div class="easy-camera-btn easy-camera-btn-icon filled-icon" 
                    @click.stop="doCancel" 
                    v-show="photo">
                    <el-icon><CloseBold /></el-icon>
                </div>
                <div class="easy-camera-btn easy-camera-btn-icon success-icon"  
                    @click.stop="doSure" 
                    v-show="photo">
                    <el-icon><Select /></el-icon>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ArrowLeft,Select,CloseBold } from "@element-plus/icons";
import uploads from "@/common/uploads";
import Camera from "simple-vue-camera";
export default {
    props: {
        maskSrc:{
            type:String,
            default:require('@/assets/images/camera/reverse.png')
        },
        photoName:{
            type:String,
            default:"idcard.jpg"
        },
    },
    components: {
        ArrowLeft,
        Select,
        CloseBold,
        Camera,
    },
    data() {
        return {
            cameraContentHeight:"height: 7.3rem",
            photo: "",
            photoBlob:null,
            // photo: "http://yizhitisheng.dev.medflying.com/files/MQI_dev/202412200001_live_1734578342_qrcode.png",
        };
    },
    created() { 
        // const windowWidth = window.innerWidth;
        // const windowHeight = window.innerHeight;
        // console.log(`屏幕宽度: ${windowWidth}px`);
        // console.log(`屏幕高度: ${windowHeight}px`);
        // const screenWidth = screen.width;
        // const screenHeight = screen.height;
        // console.log(`屏幕分辨率宽度: ${screenWidth}px`);
        // console.log(`屏幕分辨率高度: ${screenHeight}px`);
    },
    computed:{
    },
    methods: {
        getCameraHeight() {
            this.$nextTick(() => {
                const width = this.$refs.IDCardImgContainer?.clientWidth;
                const height = width / 1.59; // 根据身份证的宽高比计算高度
                this.cameraContentHeight = `height: ${height}px`;
            })
        },   
        async snapshot() {
            let width = this.$refs.camera_container.clientWidth;
            let height = this.$refs.camera_container.clientHeight;
            this.photoBlob = await this.$refs.camera?.snapshot({ width: width*5, height: height*5 }, "image/jpg", 1);
            this.photo = URL.createObjectURL(this.photoBlob);
            // console.log(this.photo,blob);
        },
        doCancel(){
            this.photoBlob = null;
            this.photo="";
        },
        async doSure(){
            let file = new File([this.photoBlob], this.photoName, { type: "image/jpg" });
            let loading = this.$tips.loading({ text: "上传中..." });
            try {
                let res = await uploads.uploadFile({
                    file,
                    key: "files",
                    item: { type: "idcard" },
                });
                loading.close();
                this.$emit("doSure",res.data[0]);
            } catch (error) {
                console.log(error);
                loading.close();
            }
            // console.log(res);
        },
        closePage(){
            this.$emit("doSure","");
        },
    },
};
</script>

<style>
/* 可以根据需要调整样式 */
.easy-camera-page{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: #302f2b;
    position: fixed;
    top: 0;
    left: 0;
}
.easy-camera-header{
    box-sizing: border-box;
    height: 1.5rem;
    padding: 0.5rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.easy-camera-header i{
    font-size: 0.8rem;
    color: #fff;
    font-weight: bold;
}
.easy-camera-content{
    width: 100%;
    flex: 1 0 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
}
.easy-camera-container{
    box-sizing: border-box;
    width: 100%;
    /* height: 7.3rem; */
    padding: 0 0.5rem;
}
.easy-camera-mask-img-container{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
}
.easy-camera-mask-img{
    width: 100%;
    height: 100%;
    position: relative;
    top: 0;
}
.easy-camera-footer{
    width: 100%;
    height: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
}
.easy-camera-btn{
    background-color: #fff;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
}
.easy-camera-btn-icon{
    display: flex;
    justify-content: center;
    align-items: center;
}
.filled-icon{
    margin-right:2rem ;
}
.filled-icon i{
    font-size: 1rem;
    color: #f00;
}
.success-icon i{
    font-size: 1rem;
    color: #07c160;
}
.easy-camera-photo-preview{
    width: 100%;
    height: 7.3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    background-color: #302f2b;
}
.easy-camera-photo-preview img{
    width: 100%;
    height: auto;
    object-fit: cover;
}
</style>